import {
  ColorSchemesType,
  ContrastColorByThemeType,
  IInitialColorScheme,
  IVizFormats,
} from './colorSchemes.interface';

// sequential
import {
  vidrisSequential,
  vidrisSequentialMixed,
  magmaSequential,
  magmaSequentialMixed,
  ceruleanSequential,
  ceruleanSequentialMixed,
} from './sequential';

// categorical
import {
  hanaCategoricalDefault,
  hanaCategoricalMixed,
  pastelCategoricalDefault,
  pastelCategoricalMixed,
  ceruleanCategoricalDefault,
  ceruleanCategoricalMixed,
  vidrisCategorical,
  vidrisCategoricalMixed,
  magmaCategoricalDefault,
  magmaCategoricalMixed,
} from './categorical';

// defaults
import {
  ceruleanDefault,
  ceruleanDefaultMixed,
  hanaDefault,
  hanaDefaultMixed,
  magmaDefault,
  magmaDefaultMixed,
  pastelDefault,
  pastelDefaultMixed,
  vidrisDefault,
  vidrisDefaultMixed,
} from './default';

// contrast colors
import {
  vidrisContrastColor,
  magmaContrastColor,
  ceruleanContrastColor,
  pastelContrastColor,
  hanaContrastColor,
} from './contrastColors';
import Themes from '../../themes';

export const sequential = {
  vidris: vidrisSequential,
  magma: magmaSequential,
  cerulean: ceruleanSequential,
};

export const categorical = {
  hana: hanaCategoricalDefault,
  pastel: pastelDefault,
};

export const colorSchemes: ColorSchemesType = {
  ...sequential,
  ...categorical,
};

export const contrastColorByTheme: ContrastColorByThemeType = {
  vidris: vidrisContrastColor,
  magma: magmaContrastColor,
  cerulean: ceruleanContrastColor,
  hana: hanaContrastColor,
  pastel: pastelContrastColor,

  // legacy colors
  'Minty inferno': Themes['Minty inferno'].theme.color[3],
  'Cerulean sequential': Themes['Cerulean sequential'].theme.color[3],
  'Forest sequential': Themes['Forest sequential'].theme.color[3],
  'Magma sequential': Themes['Magma sequential'].theme.color[3],
  'Kobai divergent': Themes['Kobai divergent'].theme.color[3],
  'Kobai categorical': Themes['Kobai categorical'].theme.color[3],
  'Vidris sequential': Themes['Vidris sequential'].theme.color[3],
  qualitative: Themes['qualitative'].theme.color[3],
  divergent: Themes['divergent'].theme.color[3],
};

export const initialColorSchemeState: IInitialColorScheme = {
  theme: 'hana',
  vizFormat: 'default',
  isMixed: false,
};

export const colorArrayOffset: number = 3;

export const vizFormats: IVizFormats = {
  default: {
    label: 'Default',
    description:
      'All visual elements of the same axis & type will be represented by the same color',
    themes: {
      hana: {
        label: 'Hana',
        default: hanaDefault,
        mixed: hanaDefaultMixed,
        contrastColor: hanaContrastColor,
      },
      cerulean: {
        label: 'Cerulean',
        default: ceruleanDefault,
        mixed: ceruleanDefaultMixed,
        contrastColor: ceruleanContrastColor,
      },
      pastel: {
        label: 'Pastel',
        default: pastelDefault,
        mixed: pastelDefaultMixed,
        contrastColor: pastelContrastColor,
      },
      vidris: {
        label: 'Vidris',
        default: vidrisDefault,
        mixed: vidrisDefaultMixed,
        contrastColor: vidrisContrastColor,
      },
      magma: {
        label: 'Magma',
        default: magmaDefault,
        mixed: magmaDefaultMixed,
        contrastColor: magmaContrastColor,
      },
    },
  },
  categorical: {
    label: 'Categorical',
    description: 'Each data entry will be represented with a different color from the pallette',
    themes: {
      hana: {
        label: 'Hana',
        default: hanaCategoricalDefault,
        mixed: hanaCategoricalMixed,
        contrastColor: hanaContrastColor,
      },
      cerulean: {
        label: 'Cerulean',
        default: ceruleanCategoricalDefault,
        mixed: ceruleanCategoricalMixed,
        contrastColor: ceruleanContrastColor,
      },
      pastel: {
        label: 'Pastel',
        default: pastelCategoricalDefault,
        mixed: pastelCategoricalMixed,
        contrastColor: pastelContrastColor,
      },
      vidris: {
        label: 'Vidris',
        default: vidrisCategorical,
        mixed: vidrisCategoricalMixed,
        contrastColor: vidrisContrastColor,
      },
      magma: {
        label: 'Magma',
        default: magmaCategoricalDefault,
        mixed: magmaCategoricalMixed,
        contrastColor: magmaContrastColor,
      },
    },
  },
  sequential: {
    label: 'Sequential',
    description:
      'Data will be represented as a sequence of grading colors in one direction according to the scale of values',
    themes: {
      cerulean: {
        label: 'Cerulean',
        default: ceruleanSequential,
        mixed: ceruleanSequentialMixed,
        contrastColor: ceruleanContrastColor,
      },
      vidris: {
        label: 'Vidris',
        default: vidrisSequential,
        mixed: vidrisSequentialMixed,
        contrastColor: vidrisContrastColor,
      },
      magma: {
        label: 'Magma',
        default: magmaSequential,
        mixed: magmaSequentialMixed,
        contrastColor: magmaContrastColor,
      },
    },
  },
};
